export const ACTIVE = 'active'
export const PAUSED = 'paused'
export const EMPTY = 'none'
